<template>
  <div class="seomain">
    <ul class="tab-tilte">
      <li
        v-for="(title, index) in tabTitle"
        @click="
          changeActiveIndex(index);
          get_st_list(index);
        "
        :class="{ active: cur == index }"
        class="text-center"
        :key="index"
      >
        <span>{{ title }}</span>
      </li>
      <div class="cl"></div>
    </ul>
    <!-- 搜索  单行 -->
    <!-- <div class="keyword">
      <van-search
        v-model="order_code"
        shape="round"
        show-action
        background="#e0e0e0"
        placeholder="请输入订单号搜索"
        @search="onSearch"
        @cancel="onCancel"
      />
    </div> -->

    <!-- 搜索 多行 -->
    <div class="keyword">
      <van-form @submit="submitKeyword">
        <van-field v-model="order_code" label="单号" placeholder="请输入单号" />
        <van-field v-model="sku" label="SKU" placeholder="SKU" />
        <div :style="{ padding: '16px', backgroundColor: '#fff' }">
          <van-button round block type="info" native-type="submit">搜 索</van-button>
        </div>
      </van-form>
    </div>
    <div class="tab-content tab-content-list">
      <div v-show="cur == 0" class="st-list-box pan-0">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
          <div class="st-list" v-for="(v, k) in stlist0" :key="v.id" :index="k">
            <router-link :to="'/saleo/info/' + v.id" class="st-list-top">
              <div class="t-tit">{{ v.ordercode }}</div>
              <div class="t-status">待出库</div>
            </router-link>
            <div class="st-list-main">
              <p>批次号：{{ v.batch }}</p>
              <p v-if="v.type == '销售订单'">
                订单类型：<span :style="{ color: '#ca151e' }">{{ v.type }}</span>
              </p>
              <p v-if="v.type == '租赁订单'">
                订单类型：<span :style="{ color: '#ff5733' }">{{ v.type }}</span>
              </p>
              <p v-if="v.type == '海外订单'">
                订单类型：<span :style="{ color: '#00baad' }">{{ v.type }}</span>
              </p>
              <p v-if="v.type == '寄售订单'">
                订单类型：<span :style="{ color: '#2a82e4' }">{{ v.type }}</span>
              </p>
              <p v-if="v.type == '投资订单'">
                订单类型：<span :style="{ color: '#f39c11' }">{{ v.type }}</span>
              </p>
              <p>包装类型：{{ v.packagetype }}</p>
              <p>销售商务：{{ v.seller_name }}</p>
              <p>
                销售电话：<a :href="'tel:' + v.seller_phone">{{ v.seller_phone }}</a>
              </p>
              <p>收货人：{{ v.receiver }}</p>
              <p>
                收货电话：<a :href="'tel:' + v.phone">{{ v.phone }}</a>
              </p>
              <p>收货地址：{{ v.adress }}</p>
            </div>
            <!-- <div class="st-list-bottom">
                        <router-link :to="'/saleo/info/'+v.id" class="st-opt-btn">出 库</router-link>
                        <router-link to="/saleo" class="st-opt-btn">出 库</router-link>
                    </div> -->
            <div class="st-list-bottom-diy">
              <div class="st-diyl-btn" @click="changQualityStatus(v.inspect, v.id)">
                <!-- <div class="st-opt-btn" @click="changQualityStatus(v.inspect, v.id)">
                  {{ v.inspect == 1 ? "已质检" : "质  检" }}
                </div> -->
                <div class="st-opt-btn" v-if="v.inspect == 0">质检</div>
                <div class="st-opt-btn" v-if="v.inspect == 1">提交审批</div>
                <div class="st-opt-btn" v-if="v.inspect == 2">审批中</div>
                <div class="st-opt-btn" v-if="v.inspect == 3">审批通过</div>
              </div>
              <div class="st-diyr-btn">
                <div class="st-opt-btn" @click="goUrl(v.inspect, '/saleo/info/' + v.id)">
                  出 库
                </div>
              </div>
            </div>
          </div>
        </van-list>
      </div>
      <div v-show="cur == 1" class="st-list-box pan-1">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
          <div class="st-list" v-for="(v, k) in stlist1" :key="v.id" :index="k">
            <div class="st-list-top">
              <div class="t-tit">{{ v.ordercode }}</div>
              <div class="t-status">待签收</div>
            </div>
            <div class="st-list-main">
              <p>批次号：{{ v.batch }}</p>
              <p v-if="v.type == '销售订单'">
                订单类型：<span :style="{ color: '#ca151e' }">{{ v.type }}</span>
              </p>
              <p v-if="v.type == '租赁订单'">
                订单类型：<span :style="{ color: '#ff5733' }">{{ v.type }}</span>
              </p>
              <p v-if="v.type == '海外订单'">
                订单类型：<span :style="{ color: '#00baad' }">{{ v.type }}</span>
              </p>
              <p v-if="v.type == '寄售订单'">
                订单类型：<span :style="{ color: '#2a82e4' }">{{ v.type }}</span>
              </p>
              <p v-if="v.type == '投资订单'">
                订单类型：<span :style="{ color: '#f39c11' }">{{ v.type }}</span>
              </p>
              <p>包装类型：{{ v.packagetype }}</p>
              <p>销售商务：{{ v.seller_name }}</p>
              <p>
                销售电话：<a :href="'tel:' + v.seller_phone">{{ v.seller_phone }}</a>
              </p>
              <p>物流公司：{{ v.logisticser }}</p>
              <p @click="getExInfo(v.id, v.type)">物流单号：{{ v.courier }}</p>
              <p>物流状态：{{ v.logistics_status }}</p>
              <p>收货人：{{ v.receiver }}</p>
              <p>
                收货电话：<a :href="'tel:' + v.phone">{{ v.phone }}</a>
              </p>
              <p>收货地址：{{ v.adress }}</p>
            </div>
            <div class="st-list-bottom-diy">
              <div class="st-diyl-btn">
                <router-link :to="'/saleo/info/' + v.id" class="st-opt-btn">查 看</router-link>
              </div>
              <div class="st-diyr-btn" v-if="v.type === '海外订单'">
                <div class="st-opt-btn" @click="showUpdataDialogHandle(v.id)">更新物流信息</div>
              </div>
            </div>
            <!-- <div class="st-list-bottom">
              <router-link :to="'/saleo/info/' + v.id" class="st-opt-btn">查 看</router-link>
            </div> -->
          </div>
        </van-list>
      </div>
      <div v-show="cur == 2" class="st-list-box pan-2">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
          <div class="st-list" v-for="(v, k) in stlist2" :key="v.id" :index="k">
            <div class="st-list-top">
              <div class="t-tit">{{ v.ordercode }}</div>
              <div class="t-status">已入库</div>
            </div>
            <div class="st-list-main">
              <p>批次号：{{ v.batch }}</p>
              <p v-if="v.type == '销售订单'">
                订单类型：<span :style="{ color: '#ca151e' }">{{ v.type }}</span>
              </p>
              <p v-if="v.type == '租赁订单'">
                订单类型：<span :style="{ color: '#ff5733' }">{{ v.type }}</span>
              </p>
              <p v-if="v.type == '海外订单'">
                订单类型：<span :style="{ color: '#00baad' }">{{ v.type }}</span>
              </p>
              <p v-if="v.type == '寄售订单'">
                订单类型：<span :style="{ color: '#2a82e4' }">{{ v.type }}</span>
              </p>
              <p v-if="v.type == '投资订单'">
                订单类型：<span :style="{ color: '#f39c11' }">{{ v.type }}</span>
              </p>
              <p>包装类型：{{ v.packagetype }}</p>
              <p>销售商务：{{ v.seller_name }}</p>
              <p>
                销售电话：<a :href="'tel:' + v.seller_phone">{{ v.seller_phone }}</a>
              </p>
              <p>物流公司：{{ v.logisticser }}</p>
              <p @click="getExInfo(v.id)">物流单号：{{ v.courier }}</p>
              <p>物流状态：{{ v.logistics_status }}</p>
              <p>收货人：{{ v.receiver }}</p>
              <p>
                收货电话：<a :href="'tel:' + v.phone">{{ v.phone }}</a>
              </p>
              <p>收货地址：{{ v.adress }}</p>
            </div>
            <div class="st-list-bottom-diy">
              <div class="st-diyl-btn">
                <router-link :to="'/saleo/info/' + v.id" class="st-opt-btn">查 看</router-link>
              </div>
              <div class="st-diyr-btn" v-if="v.type === '海外订单'">
                <div class="st-opt-btn" @click="showUpdataDialogHandle(v.id)">更新物流信息</div>
              </div>
            </div>
          </div></van-list
        >
      </div>
    </div>

    <van-dialog class="exDialog" ref="exDialog" v-model="exShow" :title="exDialogTitle">
      <van-steps direction="vertical" :active="0" active-color="#fa6e09">
        <van-step v-for="(item, index) in exDataList" :key="index">
          <h3>{{ item.time }}</h3>
          <p>{{ item.step }}</p>
        </van-step>
      </van-steps>
    </van-dialog>

    <van-dialog
      class="exDialog"
      ref="exDialog"
      v-model="updataExShow"
      title="更新物流信息"
      confirmButtonText="提交"
      @confirm="editExpress"
      showCancelButton
    >
      <van-field v-model="updataExMsg" rows="2" autosize type="textarea" placeholder="请输入信息" />
    </van-dialog>
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {
      loading: false,
      finished: false,
      page: 1,
      tabTitle: ["待出库", "待签收", "已签收"],
      order_code: "",
      cur: 0,
      status: 0,
      stlist0: [],
      stlist1: [],
      stlist2: [],
      exShow: false,
      exDialogTitle: "",
      exDataList: [],
      updataExShow: false, // 更新物流信息对话框的标识 (海外)
      updataExMsg: "",
      updataActiveId: 0,
      sku: "",
    };
  },
  watch: {},
  computed: {},
  methods: {
    async get_st_list(e) {
      this.stlist0 = [];
      this.stlist1 = [];
      this.stlist2 = [];
      this.page = 1;
      this.loading = true;
      this.finished = false;
      this.onLoad();
    },
    init() {
      let activeIndex = window.sessionStorage.getItem("saleo_activeIndex");
      if (activeIndex) {
        this.cur = activeIndex;
      }
    },
    changeActiveIndex(value) {
      this.cur = value;
      window.sessionStorage.setItem("saleo_activeIndex", value);
    },
    // 分页
    async onLoad() {
      let result = await this.$post(this.$api.stGetXiaoshouoList, {
        order_code: this.order_code,
        status: this.cur,
        page: this.page,
        sku: this.sku,
      });

      if (result.data.length == 0) return (this.finished = true);
      // 进行操作
      this["stlist" + this.cur].push(...result.data.list);
      // 操作完成
      this.page += 1;
      this.loading = false;
    },
    // 质检
    async changQualityStatus(inspect, id) {
      console.log(arguments);
      inspect = Number.parseInt(inspect);
      let result;
      switch (inspect) {
        case 0:
          // 质检操作
          result = await this.$post(this.$api.stGetXiaoshouCheck, { id });
          if (result.code == 200) {
            this.$toast.success("质检成功!");
            this.stlist0 = this.stlist0.filter((item) => {
              if (item.id == id) {
                item.inspect = 1;
              }
              return item;
            });
          }
          break;
        case 1:
          // 提交审批
          this.$toast.loading({
            message: "审批提交中...",
            forbidClick: true,
            loadingType: "spinner",
          });

          try {
            result = await this.$post(this.$api.stOutApprove, { id });
            this.stlist0 = this.stlist0.filter((item) => {
              if (item.id == id) {
                item.inspect = 2;
              }
              return item;
            });
            return this.$toast.success("已提交审批!");
          } catch (error) {
            his.$toast.fail("提交失败!");
          }

          break;
        case 2:
          this.stlist0 = this.stlist0.filter((item) => {
            if (item.id == id) {
              item.inspect = 3;
            }
            return item;
          });
          return this.$toast.fail("审批中");
          break;
        case 3:
          return this.$toast("审批已通过");
          break;
      }
      // if (inspect == 1) {
      //   this.$toast.fail("已质检");
      //   return;
      // }
    },
    goUrl(inspect, url) {
      if (inspect == 0) {
        this.$toast.fail("请先完成质检");
        return;
      }
      if (inspect == 1) {
        this.$toast.fail("请提交出库审批");
        return;
      }
      if (inspect == 2) {
        this.$toast.fail("请等待审批完成");
        return;
      }
      if (inspect == 3) {
        this.$router.push(url);
        return;
      }
    },
    // 获取物流信息
    async getExInfo(id, type) {
      if (type === "海外订单") console.log("type:海外订单");
      let { logisticser, courier } = this["stlist" + this.cur].filter((item) => item.id == id)[0];
      if (courier == null || courier.trim() == "") return;

      this.exDialogTitle = logisticser + ": " + courier;
      let result = await this.$post(this.$api.stGetXiaoshouExInfo, { id });
      if (result.data.code == 1) {
        console.log(result.data.data);
        this.exDataList = result.data.data;
      } else {
        this.exDataList = [{ step: "暂无轨迹信息,请确认订单号是否填写正确." }];
      }
      this.exShow = true;
    },
    // 打开更新物流信息对话框
    showUpdataDialogHandle(id) {
      this.updataActiveId = id;
      this.updataExShow = true;
      this.updataExMsg = "";
    },
    // 更新物流信息(海外)
    async editExpress() {
      let result = await this.$post(this.$api.stUpdataExInfo, { id: this.updataActiveId, msg: this.updataExMsg });
      if (result.code == 200) {
        this.$toast.success("更新成功");
        let list = this["stlist" + this.cur].filter((item) => {
          console.log(item.id, this.updataActiveId, this.updataExMsg);
          if (item.id == this.updataActiveId) {
            item.logistics_status = this.updataExMsg;
          }
          return item;
        });
        console.log(list);
        this["stlist" + this.cur] = list;
        console.log(this["stlist" + this.cur]);
        this.updataExShow = false;
      }
    },
    onSearch(val) {
      this["stlist" + this.cur] = [];
      this.finished = false;
      this.page = 1;
      this.onLoad();
    },
    onCancel() {},
    // 关键字搜索
    submitKeyword() {
      this["stlist" + this.cur] = [];
      this.finished = false;
      this.page = 1;
      this.onLoad();
    },
  },
  created() {
    this.init();
    window.h5sdk.ready(function() {
      window.h5sdk.biz.navigation.setTitle({ title: "销售出库" });
    });
  },
  mounted() {},
};
</script>
<style lang="scss" scoped>
.keyword {
  position: fixed;
  width: 100%;
  top: 50px;
}
/* 2行input start */
.tab-content-list {
  padding-top: 220px;
}
/* 2行input  end */

.st-list-bottom-diy {
  display: flex;
}
.st-list-bottom-diy .st-diyl-btn {
  background: #00baad;
  border-radius: 5px;
  flex: 1;
  margin-right: 8px;
}
.st-list-bottom-diy .st-diyl-btn.active {
  background: #677588;
}
.st-list-bottom-diy .st-diyr-btn {
  background: #3c8dbc;
  border-radius: 5px;
  flex: 1;
  margin-left: 8px;
}
.st-diyl-btn.checkBy {
  background-color: #677588;
}
</style>
